/* eslint-disable no-undef */
WB.Routing = WB.Routing || {};

/*
 * Register our routes.
 *
 * We don't use the native angular routing configuration heaviily.
 * Instead, we have created our own router to hook into the routing events
 * and handle custom loading and processing. We have also created a custom
 * routeProvider to handle common pieces in a general format.
 *
 * See the `routing` folder for more information on the routing process.
 */

WB.Routing.Routes = function(wbRouteProvider, $locationProvider) {
    $locationProvider.html5Mode({
        enabled: true
    });

    wbRouteProvider
        .when('/weather-forecast/now/:location', {
            name: 'forecasts',
            controller: 'forecasts',
            tab: 'current',
            pageId: 'forecasts/current',
            analytics: {
                enabled: true,
                busDomain: 'Now',
                pageName: 'Now'
            }
        })
        .when('/weather-forecast/now/', {
            name: 'forecasts',
            controller: 'forecasts',
            tab: 'current',
            pageId: 'forecasts/current',
            analytics: {
                enabled: true,
                busDomain: 'Now',
                pageName: 'Now'
            }
        })
        .when('/', {
            name: 'homepage',
            controller: 'homepage',
            tab: 'current',
            pageId: 'forecasts/current',
            analytics: {
                enabled: true,
                busDomain: 'Now',
                pageName: 'Now'
            }
        })
        .when('/weather-forecast/10-day-weather/:location', {
            name: 'forecasts.10-day-weather',
            controller: 'forecasts',
            tab: 'daily',
            pageId: 'forecasts/daily',
            analytics: {
                enabled: true,
                busDomain: 'Forecast Summary',
                pageName: '10 Day'
            }
        })
        .when('/weather-forecast/10-day-weather/', {
            name: 'forecasts.10-day-weather',
            controller: 'forecasts',
            tab: 'daily',
            pageId: 'forecasts/daily',
            analytics: {
                enabled: true,
                busDomain: 'Forecast Summary',
                pageName: '10 Day'
            }
        })
        .when('/weather-forecast/hourly/:location', {
            name: 'forecasts.hourly',
            controller: 'forecasts',
            tab: 'hourly',
            pageId: 'forecasts/hourly',
            analytics: {
                enabled: true,
                busDomain: 'Forecast Hourly',
                pageName: 'Hourly'
            }
        })
        .when('/weather-forecast/hourly/', {
            name: 'forecasts.hourly',
            controller: 'forecasts',
            tab: 'hourly',
            pageId: 'forecasts/hourly',
            analytics: {
                enabled: true,
                busDomain: 'Forecast Hourly',
                pageName: 'Hourly'
            }
        })
        .when('/maps/radar.global/:location', {
            name: 'maps.radar-global',
            controller: 'maps',
            pageId: 'maps',
            analytics: {
                enabled: true,
                busDomain: 'Maps',
                pageName: 'Maps'
            }
        })
        .when('/maps/', {
            name: 'maps',
            controller: 'maps',
            pageId: 'maps',
            analytics: {
                enabled: true,
                busDomain: 'Maps',
                pageName: 'Maps'
            }
        })
        .when('/maps/:location', {
            name: 'maps',
            controller: 'maps',
            pageId: 'maps',
            analytics: {
                enabled: true,
                busDomain: 'Maps',
                pageName: 'Maps'
            }
        })
        .when('/maps/:giv/:location', {
            name: 'maps',
            controller: 'maps',
            pageId: 'maps',
            analytics: {
                enabled: true,
                busDomain: 'Maps',
                pageName: 'Maps'
            }
        })
        .when('/alerts/weather/:location', {
            name: 'alerts.weather',
            controller: 'alerts',
            pageId: 'alerts/weather',
            analytics: {
                enabled: true,
                busDomain: 'Weather Alerts',
                pageName: 'Weather Alerts'
            }
        })
        .when('/alerts/spark/:location', {
            name: 'alerts.spark',
            controller: 'alerts',
            pageId: 'alerts/spark',
            analytics: {
                enabled: true,
                busDomain: 'Spark Alerts',
                pageName: 'Spark Alerts'
            }
        })
        .when('/alerts/hurricane/:location', {
            name: 'alerts.hurricane',
            controller: 'alerts',
            pageId: 'alerts/hurricane',
            analytics: {
                enabled: true,
                busDomain: 'Hurricane Alerts',
                pageName: 'Hurricane Alerts'
            }
        })
        .when('/alerts/fire/:location', {
            name: 'alerts.fire',
            controller: 'alerts',
            pageId: 'alerts/fire',
            analytics: {
                enabled: true,
                busDomain: 'Fire Alerts',
                pageName: 'Fire Alerts'
            }
        })
        .when('/alerts/pollen/:location', {
            name: 'alerts.pollen',
            controller: 'alerts',
            pageId: 'alerts/pollen',
            analytics: {
                enabled: true,
                busDomain: 'Pollen Alerts',
                pageName: 'Pollen Alerts'
            }
        })
        .when('/alerts/air-quality/:location', {
            name: 'alerts.airquality',
            controller: 'alerts',
            pageId: 'alerts/airquality',
            analytics: {
                enabled: true,
                busDomain: 'Air Quality Alerts',
                pageName: 'Air Quality Alerts'
            }
        })
        .when('/alerts/severe-storm-risk/:location', {
            name: 'alerts.severestormrisk',
            controller: 'alerts',
            pageId: 'alerts/severestormrisk',
            analytics: {
                enabled: true,
                busDomain: 'Severe Storm Risk Alerts',
                pageName: 'Severe Storm Risk Alerts'
            }
        })
        .when('/alerts/', {
            name: 'alerts.all',
            controller: 'alerts',
            pageId: 'alerts',
            analytics: {
                enabled: true,
                busDomain: 'All Alerts',
                pageName: 'All Alerts'
            }
        })
        .when('/alerts/weather/', {
            name: 'alerts.weather',
            controller: 'alerts',
            pageId: 'alerts/weather',
            analytics: {
                enabled: true,
                busDomain: 'Weather Alerts',
                pageName: 'Weather Alerts'
            }
        })
        .when('/alerts/spark', {
            name: 'alerts.spark',
            controller: 'alerts',
            pageId: 'alerts/spark',
            analytics: {
                enabled: true,
                busDomain: 'New Spark Alerts',
                pageName: 'New Spark Alerts'
            }
        })
        .when('/alerts/hurricane/', {
            name: 'alerts.hurricane',
            controller: 'alerts',
            pageId: 'alerts/hurricane',
            analytics: {
                enabled: true,
                busDomain: 'Hurricane Alerts',
                pageName: 'Hurricane Alerts'
            }
        })
        .when('/alerts/fire/', {
            name: 'alerts.fire',
            controller: 'alerts',
            pageId: 'alerts/fire',
            analytics: {
                enabled: true,
                busDomain: 'Fire Alerts',
                pageName: 'Fire Alerts'
            }
        })
        .when('/alerts/pollen/', {
            name: 'alerts.pollen',
            controller: 'alerts',
            pageId: 'alerts/pollen',
            analytics: {
                enabled: true,
                busDomain: 'Pollen Alerts',
                pageName: 'Pollen Alerts'
            }
        })
        .when('/alerts/air-quality/', {
            name: 'alerts.airquality',
            controller: 'alerts',
            pageId: 'alerts/airquality',
            analytics: {
                enabled: true,
                busDomain: 'Air Quality Alerts',
                pageName: 'Air Quality Alerts'
            }
        })
        .when('/alerts/severe-storm-risk/', {
            name: 'alerts.severestormrisk',
            controller: 'alerts',
            pageId: 'alerts/severestormrisk',
            analytics: {
                enabled: true,
                busDomain: 'Severe Storm Risk Alerts',
                pageName: 'Severe Storm Risk Alerts'
            }
        })
        .when('/alerts/:location', {
            name: 'alerts.all',
            controller: 'alerts',
            pageId: 'alerts',
            analytics: {
                enabled: true,
                busDomain: 'All Alerts',
                pageName: 'All Alerts'
            }
        })
        .when('/life/pollen/:location', {
            name: 'life.pollen',
            controller: 'life',
            tab: 'pollen',
            pageId: 'life/pollen',
            analytics: {
                enabled: true,
                busDomain: 'Pollen',
                pageName: 'Pollen'
            }
        })
        .when('/life/cold-flu/:location', {
            name: 'life.cold-flu',
            controller: 'life',
            tab: 'cold-flu',
            pageId: 'life/coldflu',
            analytics: {
                enabled: true,
                busDomain: 'Cold & Flu',
                pageName: 'Cold & Flu'
            }
        })
        .when('/life/outdoor-sports/:location', {
            name: 'life.outdoor-sports',
            controller: 'life',
            tab: 'outdoor-sports',
            pageId: 'life/outdoor-sports',
            analytics: {
                enabled: true,
                busDomain: 'Outdoor Sports',
                pageName: 'Outdoor Sports'
            }
        })
        .when('/life/travel/:location', {
            name: 'life.travel',
            controller: 'life',
            tab: 'travel',
            pageId: 'life/travel',
            analytics: {
                enabled: true,
                busDomain: 'Travel',
                pageName: 'Travel'
            }
        })
        .when('/life/snow-ski/:location', {
            name: 'life.snow-ski',
            controller: 'life',
            tab: 'snow-ski',
            pageId: 'life/snow-ski',
            analytics: {
                enabled: true,
                busDomain: 'Snow & Ski',
                pageName: 'Snow & Ski'
            }
        })
        .when('/life/snow-ski-detail/:location', {
            name: 'life.snow-ski-detail',
            controller: 'life',
            tab: 'snow-ski-detail',
            pageId: 'life/snow-ski-detail',
            analytics: {
                enabled: true,
                busDomain: 'Snow & Ski',
                pageName: 'Snow & Ski'
            }
        })
        .when('/life/pollen/', {
            name: 'life.pollen',
            controller: 'life',
            tab: 'pollen',
            pageId: 'life/pollen',
            analytics: {
                enabled: true,
                busDomain: 'Pollen',
                pageName: 'Pollen'
            }
        })
        .when('/life/cold-flu/', {
            name: 'life.cold-flu',
            controller: 'life',
            tab: 'cold-flu',
            pageId: 'life/coldflu',
            analytics: {
                enabled: true,
                busDomain: 'Cold & Flu',
                pageName: 'Cold & Flu'
            }
        })
        .when('/life/outdoor-sports/', {
            name: 'life.outdoor-sports',
            controller: 'life',
            tab: 'outdoor-sports',
            pageId: 'life/outdoor-sports',
            analytics: {
                enabled: true,
                busDomain: 'Outdoor Sports',
                pageName: 'Outdoor Sports'
            }
        })
        .when('/life/travel/', {
            name: 'life.travel',
            controller: 'life',
            tab: 'travel',
            pageId: 'life/travel',
            analytics: {
                enabled: true,
                busDomain: 'Travel',
                pageName: 'Travel'
            }
        })
        .when('/life/snow-ski/', {
            name: 'life.snow-ski',
            controller: 'life',
            tab: 'snow-ski',
            pageId: 'life/snow-ski',
            analytics: {
                enabled: true,
                busDomain: 'Snow & Ski',
                pageName: 'Snow & Ski'
            }
        })
        .when('/life/snow-ski-detail/', {
            name: 'life.snow-ski-detail',
            controller: 'life',
            tab: 'snow-ski-detail',
            pageId: 'life/snow-ski-detail',
            analytics: {
                enabled: true,
                busDomain: 'Snow & Ski',
                pageName: 'Snow & Ski'
            }
        })
        .when('/news/', {
            name: 'news',
            controller: 'news',
            pageId: 'news',
            analytics: {
                enabled: true,
                busDomain: 'News',
                pageName: 'News'
            }
        })
        .when('/news/:id', {
            name: 'newsstory',
            controller: 'popup',
            popup: 'Story',
            pageId: 'news',
            analytics: {
                enabled: true,
                busDomain: 'News',
                pageName: 'News Story'
            }
        })
        .when('/cameras/traffic/:id', {
            name: 'trafficcamera',
            controller: 'popup',
            popup: 'TrafficCamera',
            pageId: 'traffic-camera',
            analytics: {
                enabled: true,
                busDomain: 'Traffic Cams',
                pageName: 'Traffic Cameras'
            }
        })
        .when('/cameras/weather/:id', {
            name: 'weathercamera',
            controller: 'popup',
            popup: 'WeatherCamera',
            pageId: 'weather-camera',
            analytics: {
                enabled: true,
                busDomain: 'Weather Cams',
                pageName: 'Weather Cameras'
            }
        })
        .when('/weather-camera/', {
            name: 'weatherlandingcamera',
            controller: 'weatherlandingcamera',
            pageId: 'weather-camera',
            analytics: {
                enabled: true,
                busDomain: 'Weather Cams',
                pageName: 'Weather Cameras'
            }
        })
        .when('/weather-camera/:location', {
            name: 'weatherlandingcamera',
            controller: 'weatherlandingcamera',
            pageId: 'weather-camera',
            analytics: {
                enabled: true,
                busDomain: 'Weather Cams',
                pageName: 'Weather Cameras'
            }
        })

        .when('/weather-camera-beach-cams/:location', {
            name: 'weather-camera-beach-cams',
            controller: 'weathercategory',
            pageId: 'weather-camera',
            analytics: {
                enabled: true,
                busDomain: 'Weather Cams',
                pageName: 'Weather Cameras'
            }
        })
        .when('/weather-camera-beach-cams/', {
            name: 'weather-camera-beach-cams',
            controller: 'weathercategory',
            pageId: 'weather-camera',
            analytics: {
                enabled: true,
                busDomain: 'Weather Cams',
                pageName: 'Weather Cameras'
            }
        })

        .when('/weather-camera-city-skylines/:location', {
            name: 'weather-camera-city-skylines',
            controller: 'weathercategory',
            pageId: 'weather-camera',
            analytics: {
                enabled: true,
                busDomain: 'Weather Cams',
                pageName: 'Weather Cameras'
            }
        })
        .when('/weather-camera-city-skylines/', {
            name: 'weather-camera-city-skylines',
            controller: 'weathercategory',
            pageId: 'weather-camera',
            analytics: {
                enabled: true,
                busDomain: 'Weather Cams',
                pageName: 'Weather Cameras'
            }
        })

        .when('/weather-camera-mountain-cams/:location', {
            name: 'weather-camera-mountain-cams',
            controller: 'weathercategory',
            pageId: 'weather-camera',
            analytics: {
                enabled: true,
                busDomain: 'Weather Cams',
                pageName: 'Weather Cameras'
            }
        })
        .when('/weather-camera-mountain-cams/', {
            name: 'weather-camera-mountain-cams',
            controller: 'weathercategory',
            pageId: 'weather-camera',
            analytics: {
                enabled: true,
                busDomain: 'Weather Cams',
                pageName: 'Weather Cameras'
            }
        })

        .when('/weather-camera-stadium-cams/:location', {
            name: 'weather-camera-stadium-cams',
            controller: 'weathercategory',
            pageId: 'weather-camera',
            analytics: {
                enabled: true,
                busDomain: 'Weather Cams',
                pageName: 'Weather Cameras'
            }
        })
        .when('/weather-camera-stadium-cams/', {
            name: 'weather-camera-stadium-cams',
            controller: 'weathercategory',
            pageId: 'weather-camera',
            analytics: {
                enabled: true,
                busDomain: 'Weather Cams',
                pageName: 'Weather Cameras'
            }
        })

        .when('/weather-camera-cool-spots/:location', {
            name: 'weather-camera-cool-spots',
            controller: 'weathercategory',
            pageId: 'weather-camera',
            analytics: {
                enabled: true,
                busDomain: 'Weather Cams',
                pageName: 'Weather Cameras'
            }
        })
        .when('/weather-camera-cool-spots/', {
            name: 'weather-camera-cool-spots',
            controller: 'weathercategory',
            pageId: 'weather-camera',
            analytics: {
                enabled: true,
                busDomain: 'Weather Cams',
                pageName: 'Weather Cameras'
            }
        })

        .when('/traffic-cam/', {
            name: 'trafficlandingcamera',
            controller: 'trafficlandingcamera',
            pageId: 'traffic-camera',
            analytics: {
                enabled: true,
                busDomain: 'Traffic Cams',
                pageName: 'Traffic Cameras'
            }
        })
        .when('/traffic-cam/:location', {
            name: 'trafficlandingcamera',
            controller: 'trafficlandingcamera',
            pageId: 'traffic-camera',
            analytics: {
                enabled: true,
                busDomain: 'Traffic Cams',
                pageName: 'Traffic Cameras'
            }
        })

        .when('/weather-videos/', {
            name: 'videolanding',
            controller: 'videolanding',
            pageId: 'videos',
            analytics: {
                enabled: true,
                busDomain: 'Video',
                pageName: 'Featured Video'
            }
        })
        .when('/weather-videos/:location', {
            name: 'videolanding',
            controller: 'videolanding',
            pageId: 'videos',
            analytics: {
                enabled: true,
                busDomain: 'Video',
                pageName: 'Featured Video'
            }
        })
        .when('/weather-videos/:category/:title', {
            name: 'videolanding',
            controller: 'videolanding',
            pageId: 'videos',
            analytics: {
                enabled: true,
                busDomain: 'Video',
                pageName: 'Featured Video'
            }
        })
        .when('/videos/:id', {
            name: 'video',
            controller: 'popup',
            popup: 'Video',
            pageId: 'videos',
            analytics: {
                enabled: true,
                busDomain: 'National Video',
                pageName: 'Video'
            }
        })
        .when('/legal/privacy/', {
            name: 'privacy',
            controller: 'privacyPolicy',
            pageId: 'privacy',
            analytics: {
                enabled: true,
                busDomain: 'Privacy',
                pageName: 'Privacy'
            }
        })
        .when('/legal/terms/', {
            name: 'terms',
            controller: 'termsOfUse',
            pageId: 'terms',
            analytics: {
                enabled: true,
                busDomain: 'Terms',
                pageName: 'Terms'
            }
        })
        .when('/faq/', {
            name: 'faq.general',
            controller: 'faq',
            pageId: 'faq/general',
            analytics: {
                enabled: true,
                busDomain: 'Faq',
                pageName: 'FAQ - General'
            }
        })
        .when('/faq/general/', {
            name: 'faq.general',
            controller: 'faq',
            pageId: 'faq/general',
            analytics: {
                enabled: true,
                busDomain: 'Faq',
                pageName: 'FAQ - General'
            }
        })
        .when('/faq/android/', {
            name: 'faq.android',
            controller: 'faq',
            pageId: 'faq/android',
            analytics: {
                enabled: true,
                busDomain: 'Faq',
                pageName: 'FAQ - Android'
            }
        })
        .when('/faq/ios/', {
            name: 'faq.ios',
            controller: 'faq',
            pageId: 'faq/ios',
            analytics: {
                enabled: true,
                busDomain: 'Faq',
                pageName: 'FAQ - iOS'
            }
        })
        .when('/faq/website/', {
            name: 'faq.website',
            controller: 'faq',
            pageId: 'faq/website',
            analytics: {
                enabled: true,
                busDomain: 'Faq',
                pageName: 'FAQ - Website'
            }
        })
        .when('/faq/others/', {
            name: 'faq.others',
            controller: 'faq',
            pageId: 'faq/others',
            analytics: {
                enabled: true,
                busDomain: 'Faq',
                pageName: 'FAQ - Others'
            }
        })
        .when('/faq/accountdeletion/', {
            name: 'faq.accountdeletion',
            controller: 'faq',
            pageId: 'faq/accountdeletion',
            analytics: {
                enabled: true,
                busDomain: 'Faq',
                pageName: 'FAQ - AccountDeletion'
            }
        })
        .when('/faq/', {
            name: 'faq',
            controller: 'faq',
            pageId: 'faq',
            analytics: {
                enabled: true,
                busDomain: 'Faq',
                pageName: 'FAQ'
            }
        })
        .when('/sitemap/', {
            name: 'sitemap',
            controller: 'sitemap',
            pageId: 'sitemap',
            analytics: {
                enabled: true,
                busDomain: 'Sitemap',
                pageName: 'Sitemap'
            }
        })
        .when('/sitemap/:continent', {
            name: 'sitemap-countries',
            controller: 'sitemapcountries',
            pageId: 'sitemap',
            analytics: {
                enabled: true,
                busDomain: 'Sitemap',
                pageName: 'Sitemap'
            }
        })
        .when('/sitemap/:continent/:country/state/:state/:statecode', {
            name: 'sitemap-states-cities',
            controller: 'sitemapstatecities',
            pageId: 'sitemap',
            analytics: {
                enabled: true,
                busDomain: 'Sitemap',
                pageName: 'Sitemap'
            }
        })
        .when('/sitemap/:continent/:country/states', {
            name: 'sitemap-states',
            controller: 'sitemapstates',
            pageId: 'sitemap',
            analytics: {
                enabled: true,
                busDomain: 'Sitemap',
                pageName: 'Sitemap'
            }
        })
        .when('/sitemap/:continent/:country/:isocode', {
            name: 'sitemap-cities',
            controller: 'sitemapcities',
            pageId: 'sitemap',
            analytics: {
                enabled: true,
                busDomain: 'Sitemap',
                pageName: 'Sitemap'
            }
        })
        .when('/maps/radar.global/:location', {
            name: 'maps.radar-global',
            controller: 'maps',
            pageId: 'maps',
            analytics: {
                enabled: true,
                busDomain: 'Maps',
                pageName: 'Maps'
            }
        })
        .when('/maps/GlobalSatellite/:location', {
            name: 'maps.globalsatellite',
            controller: 'maps',
            pageId: 'maps',
            analytics: {
                enabled: true,
                busDomain: 'Maps',
                pageName: 'Maps'
            }
        })
        .when('/maps/irsat/:location', {
            name: 'maps.irsat',
            controller: 'maps',
            pageId: 'maps',
            analytics: {
                enabled: true,
                busDomain: 'Maps',
                pageName: 'Maps'
            }
        })
        .when('/maps/vis-sat/:location', {
            name: 'maps.vis-sat',
            controller: 'maps',
            pageId: 'maps',
            analytics: {
                enabled: true,
                busDomain: 'Maps',
                pageName: 'Maps'
            }
        })
        .when('/maps/lxflash-consumer/:location', {
            name: 'maps.lx',
            controller: 'maps',
            pageId: 'maps',
            analytics: {
                enabled: true,
                busDomain: 'Maps',
                pageName: 'Maps'
            }
        })
        .when('/maps/Contour.Observed.DailyRain/:location', {
            name: 'maps.daily-rain',
            controller: 'maps',
            pageId: 'maps',
            analytics: {
                enabled: true,
                busDomain: 'Maps',
                pageName: 'Maps'
            }
        })
        .when('/maps/Contour.Observed.Temperature/:location', {
            name: 'maps.temperature',
            controller: 'maps',
            pageId: 'maps',
            analytics: {
                enabled: true,
                busDomain: 'Maps',
                pageName: 'Maps'
            }
        })
        .when('/maps/Observed.Temperature.English/:location', {
            name: 'maps.temperature-english',
            controller: 'maps',
            pageId: 'maps',
            analytics: {
                enabled: true,
                busDomain: 'Maps',
                pageName: 'Maps'
            }
        })
        .when('/maps/Contour.Observed.Pressure.SeaLevel/:location', {
            name: 'maps.pressure',
            controller: 'maps',
            pageId: 'maps',
            analytics: {
                enabled: true,
                busDomain: 'Maps',
                pageName: 'Maps'
            }
        })
        .when('/maps/Observed.Pressure.SeaLevel.English/:location', {
            name: 'maps.pressure-english',
            controller: 'maps',
            pageId: 'maps',
            analytics: {
                enabled: true,
                busDomain: 'Maps',
                pageName: 'Maps'
            }
        })
        .when('/maps/Contour.Observed.Temperature.HeatIndex/:location', {
            name: 'maps.heat-index',
            controller: 'maps',
            pageId: 'maps',
            analytics: {
                enabled: true,
                busDomain: 'Maps',
                pageName: 'Maps'
            }
        })
        .when('/maps/Contour.Observed.WindChill/:location', {
            name: 'maps.wind-chill',
            controller: 'maps',
            pageId: 'maps',
            analytics: {
                enabled: true,
                busDomain: 'Maps',
                pageName: 'Maps'
            }
        })
        .when('/maps/Contour.Observed.Humidity/:location', {
            name: 'maps.humidity',
            controller: 'maps',
            pageId: 'maps',
            analytics: {
                enabled: true,
                busDomain: 'Maps',
                pageName: 'Maps'
            }
        })
        .when('/maps/Contour.Observed.WindSpeed/:location', {
            name: 'maps.wind-speed',
            controller: 'maps',
            pageId: 'maps',
            analytics: {
                enabled: true,
                busDomain: 'Maps',
                pageName: 'Maps'
            }
        })
        .when('/maps/Contour.Observed.DewPoint/:location', {
            name: 'maps.dew-point',
            controller: 'maps',
            pageId: 'maps',
            analytics: {
                enabled: true,
                busDomain: 'Maps',
                pageName: 'Maps'
            }
        })
        .when('/appdownload/', {
            name: 'appdownload',
            controller: 'appdownload',
            pageId: 'appDownload',
            analytics: {
                enabled: true,
                busDomain: 'App Download',
                pageName: 'AppDownload'
            }
        })
        .when('/education/', {
            name: 'education',
            controller: 'education',
            pageId: 'education',
            analytics: {
                enabled: true,
                busDomain: 'education',
                pageName: 'education'
            }
        })
        .when('/weather-widgets/', {
            name: 'weather-widgets',
            controller: 'weather-widgets',
            pageId: 'weather-widgets',
            analytics: {
                enabled: true,
                busDomain: 'weatherwidgets',
                pageName: 'weatherwidgets'
            }
        })
        .when('/air-quality/', {
            name: 'air-quality',
            controller: 'air-quality',
            pageId: 'air-quality',
            analytics: {
                enabled: true,
                busDomain: 'Air Quality',
                pageName: 'Air Quality'
            }
        })
        .when('/air-quality/:location', {
            name: 'air-quality',
            controller: 'air-quality',
            pageId: 'air-quality',
            analytics: {
                enabled: true,
                busDomain: 'Air Quality',
                pageName: 'Air Quality'
            }
        })
        .when('/hurricane/', {
            name: 'hurricane',
            controller: 'hurricane',
            pageId: 'hurricane',
            analytics: {
                enabled: true,
                busDomain: 'Hurricane',
                pageName: 'Hurricane'
            }
        })
        .when('/hurricane/:location', {
            name: 'hurricane',
            controller: 'hurricane',
            pageId: 'hurricane',
            analytics: {
                enabled: true,
                busDomain: 'Hurricane',
                pageName: 'Hurricane'
            }
        })
        .when('/press/', {
            name: 'press',
            controller: 'press',
            pageId: 'press',
            analytics: {
                enabled: true,
                busDomain: 'Press',
                pageName: 'Press'
            }
        })
        .when('/press/:pressArticleId', {
            name: 'pressArticle',
            controller: 'pressArticle',
            pageId: 'press',
            analytics: {
                enabled: true,
                busDomain: 'Press',
                pageName: 'Press'
            }
        })
        .when('/partners/', {
            name: 'partners',
            controller: 'partners',
            pageId: 'partners',
            analytics: {
                enabled: true,
                busDomain: 'Partners',
                pageName: 'Partners'
            }
        })
        .when('/privacyfeedback', {
            name: 'privacyfeedback',
            controller: 'privacyfeedback',
            pageId: 'privacyfeedback',
            analytics: {
                enabled: false,
                busDomain: 'privacyfeedback',
                pageName: 'privacyfeedback'
            }
        })
        .when('/uninstall/d11/', {
            name: 'uninstalld11',
            controller: 'uninstallapp',
            pageId: 'uninstallAppScreen',
            analytics: {
                enabled: false,
                busDomain: 'uninstall',
                pageName: 'uninstall'
            }
        })
        .when('/uninstall/chrome/', {
            name: 'uninstallchrome',
            controller: 'uninstallapp',
            pageId: 'uninstallAppScreen',
            analytics: {
                enabled: false,
                busDomain: 'uninstall',
                pageName: 'uninstall'
            }
        });
};
WB.Routing.Routes.$inject = ['wbRouteProvider', '$locationProvider'];

// Attach the routes
WB.App.config(WB.Routing.Routes);

// Run the router
// Essentially, run and process Middleware
WB.App.run(WB.Routing.Router);
